module.exports = __webpack_public_path__ + "static/media/29FUNOV7.dc519b29.jpg";